"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathHelper = void 0;
var string_1 = require("@devexpress/utils/lib/utils/string");
var PathHelper = (function () {
    function PathHelper() {
    }
    PathHelper.getDir = function (filePath) {
        var index = filePath.lastIndexOf('/');
        return index == -1 ? '' : filePath.substring(0, index);
    };
    PathHelper.getFileName = function (filePath) {
        var index = filePath.lastIndexOf('/');
        return index == -1 ? filePath : filePath.substr(index + 1);
    };
    PathHelper.getFileExtension = function (filePath) {
        var index = filePath.lastIndexOf('.');
        return filePath.substr(index + 1);
    };
    PathHelper.normalize = function (filePath) {
        return string_1.StringUtils.startsAt(filePath, '/') ? filePath.substr(1) : filePath;
    };
    return PathHelper;
}());
exports.PathHelper = PathHelper;
